import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initRaygun } from './app/main/shared/services/raygun.service';

// Attach Raygun before bootstrap so early errors are captured
initRaygun();

// AG Grid registration lives in app/main/shared/ag-grid-setup.ts, imported by
// grid-rendering components so it stays out of the initial bundle.

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
